import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    UrlTree,
    CanActivateChild
} from '@angular/router';
import { UserService } from 'src/app/modules/core/services/user.service';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';
import { RequestService } from './request.service';

@Injectable({
    providedIn: 'root',
})
export class RouteGuardService implements CanActivate, CanActivateChild {

    constructor(private userService: UserService,
                private authService: AuthenticationService,
                private router: Router,
                private requestService: RequestService) {

    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        if (!this.authService.getAcessToken()) {
            console.log('no auth token, taking to login page');
            return this.toLogin(state);
        } else if (this.authService.shouldRefreshToken()) {
            console.log('token expired, refreshing');
            let refreshed = await this.requestService.refreshToken();
            if (!refreshed) {
                return this.toLogin(state);
            }
        }

        const currentUser = await this.userService.getCurrentUserAsync();
        if ((state.url.includes('/plantings/') && state.url.includes('/videos') && currentUser.permissions.canManagePlantingAreasVideo) ||
            (state.url.includes('/plantings/') && state.url.includes('/images') && currentUser.permissions.canManagePlantingAreasImage)) {
                return true;
        }

        if ((state.url.includes('/plantings/') && !currentUser.permissions.canManagePlantingSites) ||
            (state.url.includes('/admin/users') && !currentUser.permissions.canManageUsers) ||
            (state.url.includes('/admin/customers') && !currentUser.permissions.canManageCustomers) ||
            (state.url.includes('/certificates') && !currentUser.permissions.canManageCertificates) ||
            (state.url.includes('/new/general') && !currentUser.permissions.canManagePlantingSites)) {
                return this.router.navigate(['admin/login']);
        }

        return true;
    }

    toLogin(state: RouterStateSnapshot) {
        return this.router.createUrlTree(['/admin', 'login'],
            {
                queryParams: this.authService.getQueryParamsForRedirect(state.url)
            });
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot,
                     state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.canActivate(childRoute, state);
    }
}
